require("@rails/ujs").start();
require("turbolinks").start();

// Limitless
import "limitless/bootstrap.bundle.min";
import "limitless/uniform.min";

// Lib JS
import "jquery-validation";
import "jquery-validation/dist/localization/messages_pt_BR.js";
import "lightbox2/dist/css/lightbox";
import lightbox from "lightbox2/dist/js/lightbox";

document.addEventListener("turbolinks:load", function () {
  lightbox.option({
    albumLabel: "Imagem %1 de %2",
  });
  lightbox.init();

  const documentMaskBehavior = function (val) {
    return val.replace(/\D/g, "").length <= 11
      ? "000.000.000-009"
      : "00.000.000/0000-00";
  };
  const documentMaskOptions = {
    onKeyPress: function (val, e, field, options) {
      field.mask(documentMaskBehavior.apply({}, arguments), options);
    },
  };

  $(".mask-document").each(function () {
    const $el = $(this);
    $el.off(".maskDocumentCnpj");
    $el.unmask();
    $el.mask(documentMaskBehavior, documentMaskOptions);
    $el.on("input.maskDocumentCnpj keyup.maskDocumentCnpj", function () {
      const digits = this.value.replace(/\D/g, "");
      $el.closest("form").find(".responsible-fields").toggle(digits.length > 11);
    });
    $el.trigger("input");
  });

  $(".mask-cpf").each(function () {
    $(this).unmask();
    $(this).mask("000.000.000-00");
  });
});

// CSS
import "css/admin";
import "shared/init";
import "admin/init";

// Custom JS
import "admin/client";
import "admin/order";
import "admin/user";
import "admin/construction";

// Chat
import "chat";
